import { create } from "zustand";
import { useWorkOrders } from "../../useWorkOrders";
import moment from "moment";
import { frontDB } from "../../../../frontDB";
import api from "../../../../api";
import { showToast } from "../../../../Components/Toast";

export let useWorkOrdersHeader = create((set, get) => ({
  filter: {
    locationId: "*",
    status: "*",
    number: "*",
    componentId: "*",
    jobId: "*",
    responsibleId: "*",
  },
  woPrefix: "",
  searchNumber: "",

  setSelectedLocation: () => {
    let { location } = frontDB.getState();
    let currentFilter = get().filter;
    let newLocationId = !location ? "*" : location._id;

    // Only update if the location actually changed
    if (currentFilter.locationId === newLocationId) {
      return;
    }

    set({ filter: { ...currentFilter, locationId: newLocationId } });
    set({ woPrefix: location ? location.prefix : "" });
  },

  locationHandler: (value) => {
    set({ filter: { ...get().filter, locationId: value } });
    let { locations } = frontDB.getState();
    const location = locations.find((loc) => loc._id === value);
    set({ woPrefix: location ? location.prefix : "" });
    console.log("Location changed to:", get().woPrefix);
    useWorkOrders.setState({ activePage: 1 });
  },

  statusHandler: (value) => {
    if (value != "planned") set({ plannedType: "all" });

    if (value == "planned") {
      set({
        period: {
          ...get().period,
          from: moment().utc().subtract(6, "month").startOf("day").toDate(),
        },
      });
    }

    set({ filter: { ...get().filter, status: value } });
    useWorkOrders.setState({ activePage: 1 });
  },

  searchClearHandler: (id) => {
    set({ searchNumber: "" });
    set({ filter: { ...get().filter, number: "*" } });
  },
  searchByNumberHandler: (workorderNumber) => {
    // Update input display immediately
    set({ searchNumber: workorderNumber });

    // Only trigger search if 4 or more digits, or if empty (to reset)
    if (workorderNumber.length === 0) {
      set({ filter: { ...get().filter, number: "*" } });
      useWorkOrders.setState({ activePage: 1 });
      return;
    }

    if (workorderNumber.length >= 3) {
      if (!/^\d+$/.test(workorderNumber)) return;
      set({ filter: { ...get().filter, number: workorderNumber } });
      useWorkOrders.setState({ activePage: 1 });
    }
    // If less than 4 digits, input shows the value but search is not triggered
  },

  componentHandler: (componentId) => {
    set({ filter: { ...get().filter, componentId } });
    useWorkOrders.setState({ activePage: 1 });
  },

  jobHandler: (jobId) => {
    //console.log(jobId);
    set({ filter: { ...get().filter, jobId } });
    useWorkOrders.setState({ activePage: 1 });
  },

  responsibleHandler: (responsibleId) => {
    set({ filter: { ...get().filter, responsibleId } });
    useWorkOrders.setState({ activePage: 1 });
  },

  period: {
    from: moment().utc().subtract(3, "month").startOf("day").toDate(),
    to: moment().utc().add(1, "day").endOf("day").toDate(),
  },

  periodFromHandler: (v, e) => {
    if (!v) return;
    let from = moment(v).utc().startOf("day").format();
    set({ period: { ...get().period, from } });
    useWorkOrders.setState({ activePage: 1 });
  },

  periodToHandler: (v, e) => {
    if (!v) return;
    let to = moment(v).utc().startOf("day").format();
    set({ period: { ...get().period, to } });
    useWorkOrders.setState({ activePage: 1 });
  },

  periodRangeHandler: (range) => {
    if (!Array.isArray(range) || range.length !== 2) return;

    const [fromValue, toValue] = range;
    if (!fromValue || !toValue) return;

    set({
      period: {
        from: moment(fromValue).utc().startOf("day").toDate(),
        to: moment(toValue).utc().endOf("day").toDate(),
      },
    });

    useWorkOrders.setState({ activePage: 1 });
  },

  onCleanPeriod: () => {
    set({
      period: {
        from: moment().utc().startOf("day").toDate(),
        to: moment().utc().endOf("month").startOf("day").toDate(),
      },
    });
  },

  plannedType: "all",

  plannedTypeHandler: (v) => {
    set({ plannedType: v });
    useWorkOrders.setState({ activePage: 1 });
  },

  generatingRL: false,

  onExport: async (workOrdersLength) => {
    if (!workOrdersLength) {
      showToast("e", "No work orders were found in the search results.");
      return;
    }

    const { filter, period, plannedType } = get();

    if (filter.locationId == "*") {
      showToast("e", "Choose a vessel name before exporting work orders list");
      return;
    }

    const options = { filter, period, plannedType };

    set({ generatingRL: true });

    const response = await api.workOrder.generateWorkOrdersExcel(options);

    const fileBlob = response?.data;
    if (!fileBlob) {
      set({ generatingRL: false });
      showToast("e", "Error generating work orders export file");
      return;
    }

    let { locations } = frontDB.getState();
    const vessel = locations.find((obj) => obj._id === filter.locationId);
    const vesselName = vessel?.name || "All vessels";

    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    const filename = `${vesselName} workorders ${day}-${month}-${year}_${hour}-${minute}.xlsx`;

    const blob = new Blob([fileBlob], { type: fileBlob.type });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    set({ generatingRL: false });
  },
}));
